import { conversationSteps, buildFormThankYouMessage } from '../utils/conversationFlow';
import {
  loadSavedLeadInfo,
  saveLeadInfoToStorage,
  saveConversationToStorage,
  generateSessionId,
} from '../utils/storage';
import { createAirtableSession, scheduleBotReply } from '../utils/helpers';
import { replacePlaceholders, nextMessageId } from '../utils/aiResponseProcessor';

const useFormSubmit = ({
  state, dispatch, communityNid, config,
}) => {
  const handleFormSubmit = (submitButton, values) => {
    const {
      conversationState,
      messages,
      sessionId,
      amenityPlaces,
    } = state;

    dispatch({ type: 'SET_IS_FORM_SUBMITTED', payload: true });

    const savedLeadInfo = loadSavedLeadInfo();
    const isNewUser = !savedLeadInfo
      || savedLeadInfo.email !== values.email
      || savedLeadInfo.firstName !== values.firstName
      || savedLeadInfo.lastName !== values.lastName;

    let activeSessionId = sessionId;
    if (isNewUser) {
      activeSessionId = generateSessionId();
      dispatch({ type: 'SET_SESSION_ID', payload: activeSessionId });
    }

    saveLeadInfoToStorage({
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      phone: values.phone,
    });

    createAirtableSession(activeSessionId, values, communityNid);

    const updatedState = {
      ...conversationState,
      userInfo: { ...conversationState.userInfo, ...values },
      currentStep: submitButton.nextStep,
    };

    if (submitButton.nextStep === 'interests_selection') {
      dispatch({ type: 'SET_FLOW_STEP', payload: 2 });
    }

    const nextStep = conversationSteps[submitButton.nextStep];
    if (nextStep) {
      const botMessage = replacePlaceholders(nextStep.message, updatedState, config);

      const buildInterestButtons = (categories) => categories.map((cat) => ({
        text: cat.label,
        action: 'toggle_interest',
        interest: cat.uuid,
        interestLabel: cat.label,
      }));

      const thankYouMessage = buildFormThankYouMessage(values.firstName, config);

      dispatch({ type: 'REPLACE_CONVERSATION_STATE', payload: updatedState });

      scheduleBotReply(dispatch, () => {
        const messagesWithThankYou = [...messages, thankYouMessage];
        dispatch({ type: 'APPEND_MESSAGES', payload: [thankYouMessage] });

        scheduleBotReply(dispatch, () => {
          const categories = state.interestCategories || [];
          const stepButtons = submitButton.nextStep === 'interests_selection' && categories.length > 0
            ? buildInterestButtons(categories)
            : nextStep.buttons || [];

          const botResponse = {
            id: nextMessageId(),
            type: 'bot',
            text: botMessage,
            instructions: nextStep.instructions || null,
            buttons: stepButtons,
            continueButton: nextStep.continueButton || null,
            stepType: nextStep.type,
          };

          dispatch({ type: 'APPEND_MESSAGES', payload: [botResponse] });
          saveConversationToStorage(
            sessionId,
            [...messagesWithThankYou, botResponse],
            updatedState,
            {},
            amenityPlaces,
          );
        });
      });
    }
  };

  return { handleFormSubmit };
};

export default useFormSubmit;
